/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Registry_TitleInputs */

const en_mk_team_registry_title = /** @type {(inputs: Mk_Team_Registry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any agent`)
};

const id_mk_team_registry_title = /** @type {(inputs: Mk_Team_Registry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent mana pun`)
};

/**
* | output |
* | --- |
* | "Any agent" |
*
* @param {Mk_Team_Registry_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_registry_title = /** @type {((inputs?: Mk_Team_Registry_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Registry_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_registry_title(inputs)
	return en_mk_team_registry_title(inputs)
});